import { Component, OnInit } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { StrategyService } from '../../services/strategy.service';
import { Strategy } from '../../interfaces/models/strategy.model';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ReportsService } from '../../services/reports.service';
import { IProjectReportSummary, IUnitWithProject } from '../../interfaces/models/report.model';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../../services/admin.service';
import { IDepartment } from '../../interfaces/models/admin.model';
import { SocketService } from '../../services/socket.service';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../services/direction.service';
import { TooltipModule } from 'primeng/tooltip';
import { NavTitlePipe } from '../../pipes/nav-title.pipe';
@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [
    NavTitlePipe,DropdownModule, TagModule, FormsModule, CommonModule, TableModule, ButtonModule, TranslateModule, TooltipModule],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent implements OnInit {

  selectedStrategyId = 0;
  year = 0;
  strategyOptions = [] as { name: string, strategyId: number }[];
  targetStrategy = {} as Strategy;
  yearsOpthions = [] as number[]
  reports = [] as any[]
  selectedType = "";
  isDownloading = false;
  dir!: 'rtl' | 'ltr';
  departmentOptions = [] as { label: string, id: number | string }[];
  projects: IUnitWithProject[] = [];
  indicators = [] as any[];
  projectSummary!: IProjectReportSummary;
  selectedDepartmentStatusId: string | number = 0;
  departments = [] as {}[];

  projectStatusYears = [] as {}[];
  projectStatusYear: { id: string | number, name: string } = {
    id: 'all',
    name: ""
  }

  projectsBudjet = [] as any[]
  selectedDepartmentBudgetId: number | string = 'all';
  projectBudgetYear: { id: string | number, name: string } = {
    id: 'all',
    name: ""
  }

  constructor(
    private strategyService: StrategyService,
    private reportsService: ReportsService,
    private toastr: ToastrService,
    private adminService: AdminService,
    private socketService: SocketService,

    private directionService: DirectionService
  ) {
  }

  ngOnInit(): void {

    //strategy options dropdownList
    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })
    this.strategyService.selectedStrategy$.subscribe(selectedStrategy => {

      this.targetStrategy = selectedStrategy || {} as Strategy;

      this.yearsOpthions = selectedStrategy?.years || [] as number[];
      this.projectStatusYears = selectedStrategy?.years || [] as number[];
      this.setYears(this.projectStatusYears);
      this.projectStatusYear = this.projectStatusYears.find((year: any) => year.id == 'all') as any;
      this.projectBudgetYear = this.projectStatusYears.find((year: any) => year.id == 'all') as any;
    })

    this.strategyService.defaultStrategy$.subscribe(defaultStrategy => {
      this.targetStrategy = defaultStrategy || {} as Strategy;
      this.selectedStrategyId = defaultStrategy?.id || 0;
      this.year = defaultStrategy?.years[0] as number;
      this.yearsOpthions = defaultStrategy?.years || [] as number[];


      //years
      this.projectStatusYears = defaultStrategy?.years || [] as number[];
      this.setYears(this.projectStatusYears);
      this.projectStatusYear = this.projectStatusYears.find((year: any) => year.id == 'all') as any;
      this.projectBudgetYear = this.projectStatusYears.find((year: any) => year.id == 'all') as any;
    });

    this.reportsService.getIndicatorResultsJsonReport$.subscribe((response: any) => {
      this.indicators = structuredClone(response['data']['indicators'])
      this.selectedType = "indicators-results";
    })

    this.adminService.getListDepartments().subscribe((response: any) => {
      const departments = response['data']['departments'] as IDepartment[]
      this.departmentOptions = departments.map(x => {
        return { label: x.name, id: x.id } as { label: string, id: number }
      })
      this.setDepartments(this.departmentOptions as [])
      this.selectedDepartmentStatusId = this.departmentOptions[0]['id'];
      this.selectedDepartmentBudgetId = this.departmentOptions[0]['id'];
    })

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.setYears(this.projectStatusYears);
      this.setDepartments(this.departmentOptions as [])

      if (dir == 'ltr') {
        this.reports = [
          {
            id: "indicators-results",
            name: "View Indicator Results Report for the year",
            icon: "fa-solid fa-chart-column",
            hasDate: true,
            hasProjects: false
          },
          {
            id: "projects-status",
            name: "View Initiatives Status Report",
            icon: "fa-solid fa-table-list",
            hasProjects: true
          },
          {
            id: "projects-budgets",
            name: "View Initiatives Budget Report",
            icon: "fa-solid fa-coins",
            hasDate: false,
            hasBudget: true
          }
        ]
      } else {
        this.reports = [
          {
            id: "indicators-results",
            name: "استعراض تقرير نتائج المؤشرات",
            icon: "fa-solid fa-chart-column",
            hasDate: true,
            hasProjects: false
          },
          {
            id: "projects-status",
            name: "استعراض تقرير حالة المبادرات",
            icon: "fa-solid fa-table-list",
            hasProjects: true
          },
          {
            id: "projects-budgets",
            name: "استعراض تقرير ميزانية المبادرات",
            icon: "fa-solid fa-coins",
            hasDate: false,
            hasBudget: true
          }
        ]
      }

    })
  }
  strategyOptionsChange() {
    this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.socketService.setRefreshNotification(this.selectedStrategyId)

  }

  yearChange() {
    this.reportsService.setyearSub(this.year, this.selectedStrategyId)
  }
  progressColors = {
    0: "#cc3300",
    25: "#ff9966",
    50: "#ffcc00",
    75: "#99cc33",
    100: "#339900"
  }

  getProgressColor(progressPercentage: number) {
    if (progressPercentage == 0) return this.progressColors[0]
    if (progressPercentage > 0 && progressPercentage <= 25) return this.progressColors[0]
    if (progressPercentage > 0 && progressPercentage <= 25) return this.progressColors[25]
    if (progressPercentage > 25 && progressPercentage <= 50) return this.progressColors[50]
    if (progressPercentage > 50 && progressPercentage <= 75) return this.progressColors[75]
    if (progressPercentage > 75 && progressPercentage <= 100) return this.progressColors[100]
    return;
  }
  downloadFile(type: string, fileType: string) {

    this.isDownloading = true;
    this.selectedType = type;
    switch (type) {
      case "projects-status":
        const locale = this.dir === 'rtl' ? 'ar' : 'en';
        this.reportsService.downloadProjectsStatusReport(this.selectedStrategyId, fileType, locale).subscribe((x) => {
          this.isDownloading = false;
          const blob = new Blob([x], { type: x.type });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = "";
          anchor.click();
          window.URL.revokeObjectURL(url);
        }, (err) => {
          if (this.dir == 'rtl') {
            this.toastr.error('حدث خطأ أثناء تحميل التقرير');
          } else {
            this.toastr.error('error downloading the report');
          }
        })
        break;
      case "projects-budgets":
        const localeBudget = this.dir === 'rtl' ? 'ar' : 'en';
        this.reportsService.downloadProjectsBudgetReport(this.selectedStrategyId, fileType, localeBudget)
          .subscribe((x) => {
            this.isDownloading = false;
            const blob = new Blob([x], { type: x.type });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = "";
            anchor.click();
            window.URL.revokeObjectURL(url);
          }, (err) => {
            if (this.dir == 'rtl') {
              this.toastr.error('حدث خطأ أثناء تحميل التقرير');
            } else {

              this.toastr.error('error downloading the report');
            }
          })
        break;
      case "indicators-results":
        const localeIndicators = this.dir === 'rtl' ? 'ar' : 'en';
        this.reportsService.downloadIndicatorResultsReport(this.selectedStrategyId, this.year, fileType, localeIndicators)
          .subscribe({
            next: (x) => {
              this.isDownloading = false;
              const blob = new Blob([x], { type: x.type });
              const url = window.URL.createObjectURL(blob);
              const anchor = document.createElement('a');
              anchor.href = url;
              const fileName = `Indicators_Report_${this.year}.${fileType === 'pdf' ? 'pdf' : 'xlsx'}`;
              anchor.download = fileName;
              anchor.click();
              window.URL.revokeObjectURL(url);
              
              if (this.dir == 'rtl') {
                this.toastr.success('تم تحميل التقرير بنجاح');
              } else {
                this.toastr.success('Report downloaded successfully');
              }
            },
            error: (err) => {
              this.isDownloading = false;
              console.error('Download error:', err);
              
              // Try to read error message from blob
              if (err.error instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                  try {
                    const errorObj = JSON.parse(reader.result as string);
                    console.error('Backend error:', errorObj);
                    if (this.dir == 'rtl') {
                      this.toastr.error(errorObj.message || 'حدث خطأ أثناء تحميل التقرير');
                    } else {
                      this.toastr.error(errorObj.message || 'Error downloading the report');
                    }
                  } catch (e) {
                    if (this.dir == 'rtl') {
                      this.toastr.error('حدث خطأ أثناء تحميل التقرير');
                    } else {
                      this.toastr.error('Error downloading the report');
                    }
                  }
                };
                reader.readAsText(err.error);
              } else {
                if (this.dir == 'rtl') {
                  this.toastr.error('حدث خطأ أثناء تحميل التقرير');
                } else {
                  this.toastr.error('Error downloading the report');
                }
              }
            }
          })
        break;
    }
  }


  showReportInTable(type: string) {
    this.selectedType = type;
    switch (type) {
      case "projects-status":
        this.reportsService.getProjectsStatusReport(this.selectedStrategyId, this.selectedDepartmentStatusId, this.projectStatusYear.id).subscribe((response: any) => {
          this.projects = [];
          const { projects, summary } = response["data"];
          this.projects = projects;
        })
        break;
      case "projects-budgets":
        this.reportsService.getProjectsBudgetJsonReport(this.selectedStrategyId, this.selectedDepartmentBudgetId, this.projectStatusYear.id).subscribe((response: any) => {
          const { projects } = response['data'];
          this.projectsBudjet = projects;
        })
        break;
      case "indicators-results":
        this.reportsService.getIndicatorResultsJsonReport(this.selectedStrategyId, this.year).subscribe((response: any) => {
          this.indicators = response['data']['indicators']
        })
        break;
    }
  }
  /**
   * طباعة التقرير الحالي
   */
  printReport(reportType: string) {
    if (!this.selectedType || this.selectedType !== reportType) {
      this.toastr.warning(
        this.dir === 'rtl' ? 'يرجى عرض التقرير أولاً قبل الطباعة' : 'Please view the report first before printing',
        this.dir === 'rtl' ? 'تنبيه' : 'Warning'
      );
      return;
    }

    // إخفاء الأزرار والعناصر غير المرغوبة قبل الطباعة
    const printContent = document.querySelector('.report-results');
    if (!printContent) {
      this.toastr.error(
        this.dir === 'rtl' ? 'لا يوجد تقرير لطباعته' : 'No report to print',
        this.dir === 'rtl' ? 'خطأ' : 'Error'
      );
      return;
    }

    // فتح نافذة الطباعة
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      this.toastr.error(
        this.dir === 'rtl' ? 'فشل فتح نافذة الطباعة' : 'Failed to open print window',
        this.dir === 'rtl' ? 'خطأ' : 'Error'
      );
      return;
    }

    // الحصول على اسم التقرير
    const reportName = this.reports.find(r => r.id === reportType)?.name || 'Report';
    
    // إنشاء HTML للطباعة
    const currentDate = new Date().toLocaleDateString(this.dir === 'rtl' ? 'ar-SA' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    
    const doc = printWindow.document;
    doc.open();
    doc.close();

    const html = doc.documentElement;
    html.setAttribute('dir', this.dir);
    html.setAttribute('lang', this.dir === 'rtl' ? 'ar' : 'en');

    const head = doc.createElement('head');
    const meta = doc.createElement('meta');
    meta.setAttribute('charset', 'UTF-8');
    head.appendChild(meta);

    const title = doc.createElement('title');
    title.textContent = `${reportName} - ${currentDate}`;
    head.appendChild(title);

    const style = doc.createElement('style');
    style.textContent = this.getPrintStyles();
    head.appendChild(style);
    html.appendChild(head);

    const body = doc.createElement('body');

    const header = doc.createElement('div');
    header.className = 'print-header';

    const logo = doc.createElement('img');
    logo.className = 'print-logo';
    logo.src = `${window.location.origin}/assets/images/sharjah-airport-logo.png`;
    logo.alt = 'مطار الشارقة';
    header.appendChild(logo);

    const brandName = doc.createElement('p');
    brandName.className = 'brand-name';
    brandName.textContent = this.dir === 'rtl' ? 'مطار الشارقة' : 'Sharjah Airport';
    header.appendChild(brandName);

    const brandSystem = doc.createElement('p');
    brandSystem.className = 'brand-system';
    brandSystem.textContent = this.dir === 'rtl' ? 'نظام الاستراتيجية الذكية' : 'Smart Strategy System';
    header.appendChild(brandSystem);

    const heading = doc.createElement('h1');
    heading.textContent = reportName;
    header.appendChild(heading);

    const dateLine = doc.createElement('p');
    dateLine.className = 'date';
    dateLine.textContent = `${this.dir === 'rtl' ? 'تاريخ الطباعة:' : 'Print Date:'} ${currentDate}`;
    header.appendChild(dateLine);

    body.appendChild(header);

    const contentHost = doc.createElement('div');
    contentHost.id = 'print-report-content';
    contentHost.appendChild(printContent.cloneNode(true));
    body.appendChild(contentHost);

    html.appendChild(body);

    printWindow.focus();
    
    // تأخير بسيط للتأكد من تحميل المحتوى
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  }

  private getPrintStyles(): string {
    const textAlign = this.dir === 'rtl' ? 'right' : 'left';
    return `
      * { box-sizing: border-box; }
      body { margin: 0; padding: 30px; font-family: 'Cairo', sans-serif; background: white; color: #2c3e50; direction: ${this.dir}; }
      .print-header { text-align: center; margin-bottom: 30px; padding-bottom: 20px; border-bottom: 3px solid #C91F3B; }
      .print-header .print-logo { display: block; margin: 0 auto 12px; max-height: 90px; max-width: 220px; }
      .print-header .brand-name { color: #C91F3B; font-size: 20px; font-weight: 800; margin: 0; }
      .print-header .brand-system { color: #64748b; font-size: 14px; font-weight: 600; margin: 4px 0 12px; }
      .print-header h1 { color: #C91F3B; font-size: 28px; margin: 0 0 10px 0; font-weight: 800; }
      .print-header .date { color: #64748b; font-size: 14px; font-weight: 600; }
      table { width: 100%; border-collapse: collapse; margin-top: 20px; }
      th, td { border: 1px solid #e2e8f0; padding: 14px 16px; text-align: ${textAlign}; }
      th { background: #C91F3B; color: white; font-weight: 700; font-size: 14px; }
      tbody tr:nth-child(even) { background-color: #f8fafc; }
      @page { margin: 1.5cm; size: A4; }
      @media print { body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } }
    `;
  }

  getSeverity(status: string) {
    switch (status) {
      case 'قيد التنفيذ':
        return 'warning';
      case 'متوقفة':
        return 'danger';
      case 'مرفوضة':
        return 'danger';
      case 'نفذت':
        return 'success';
      default:
        return '';
    }
  }
  dpartmentStatusChange() {
    this.selectedType = "projects-status"
    this.reportsService.getProjectsStatusReport(
      this.selectedStrategyId,
      this.selectedDepartmentStatusId,
      this.projectStatusYear.id)
      .subscribe((response: any) => {
        const { projects } = response['data'];
        console.log(projects);
        this.projects = projects;
      })
  };

  projectStatusYearChange() {

    this.selectedType = "projects-status"


    this.reportsService.getProjectsStatusReport(
      this.selectedStrategyId,
      this.selectedDepartmentStatusId,
      this.projectStatusYear.id)
      .subscribe((response: any) => {
        const { projects } = response['data'];
        this.projects = projects;
      })

  }



  projectBudgetChange() {
    this.selectedType = "projects-budgets"
    this.reportsService.getProjectsBudgetJsonReport
      (this.selectedStrategyId,
        this.selectedDepartmentBudgetId,
        this.projectBudgetYear.id)
      .subscribe((response: any) => {
        const { projects } = response['data'];
        this.projectsBudjet = projects;
      })
  }
  projectBudgetYearChange() {

    this.selectedType = "projects-budgets"
    this.reportsService.getProjectsBudgetJsonReport(this.selectedStrategyId,
      this.selectedDepartmentBudgetId,
      this.projectBudgetYear.id).subscribe((response: any) => {
        const { projects } = response['data'];
        this.projectsBudjet = projects;
      })
  }

  setYears(resYears: {}[]) {
    this.projectStatusYears = [
      ...resYears.map((year: any) => {
        return {
          name: typeof year == "object" ? year.name : year,
          id: typeof year == "object" ? year.id : year,
        }
      })
    ];
    if (this.projectStatusYears.find((year: any) => year.id == "all")) this.projectStatusYears.shift();
    this.projectStatusYears.unshift(
      {
        name: this.dir == "ltr" ? "All Years" : "كل الأعوام",
        id: "all"
      }
    );
    if (this.projectStatusYear.id == "all") this.projectStatusYear = this.projectStatusYears.find((year: any) => year.id == "all") as any;
    if (this.projectBudgetYear.id == "all") this.projectBudgetYear = this.projectStatusYears.find((year: any) => year.id == "all") as any;

  };



  setDepartments(resDeps: [] = []) {
    this.departmentOptions = [...resDeps]
    if (this.departmentOptions.find((department: any) => department.id == "all")) this.departments.shift();
    this.departmentOptions.unshift(
      {
        label: this.dir == "ltr" ? "All Organization's Departments" : "كل إدارات المؤسسة",
        id: "all"
      } as any
    );

    if (this.selectedDepartmentBudgetId == "all") {
      // this.selectedDepartment = this.departments.find((departments: any) => departments.id == "all") as any;
    }
    if (this.selectedDepartmentStatusId == "all") {
      // this.selectedDepartment = this.departments.find((departments: any) => departments.id == "all") as any;
    }
  };
}


